var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element-equal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.8333H10C9.72667 10.8333 9.5 10.6067 9.5 10.3333C9.5 10.06 9.72667 9.83333 10 9.83333H14C14.2733 9.83333 14.5 10.06 14.5 10.3333C14.5 10.6067 14.2733 10.8333 14 10.8333Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 13.5H10C9.72667 13.5 9.5 13.2733 9.5 13C9.5 12.7267 9.72667 12.5 10 12.5H14C14.2733 12.5 14.5 12.7267 14.5 13C14.5 13.2733 14.2733 13.5 14 13.5Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6667 5.68V2.65333C14.6667 1.71333 14.24 1.33333 13.18 1.33333H10.4867C9.42667 1.33333 9 1.71333 9 2.65333V5.67333C9 6.62 9.42667 6.99333 10.4867 6.99333H13.18C14.24 7 14.6667 6.62 14.6667 5.68Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7 5.68V2.65333C7 1.71333 6.57333 1.33333 5.51333 1.33333H2.82C1.76 1.33333 1.33333 1.71333 1.33333 2.65333V5.67333C1.33333 6.62 1.76 6.99333 2.82 6.99333H5.51333C6.57333 7 7 6.62 7 5.68Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7 13.18V10.4867C7 9.42667 6.57333 9 5.51333 9H2.82C1.76 9 1.33333 9.42667 1.33333 10.4867V13.18C1.33333 14.24 1.76 14.6667 2.82 14.6667H5.51333C6.57333 14.6667 7 14.24 7 13.18Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionType);
export default __webpack_public_path__ + "static/media/OptionType.e5b59a5217f3a8cccffd59039c8ae64f.svg";
export { ForwardRef as ReactComponent };